"use client";

import classNames from "classnames";
import { useEffect } from "react";
import { LoadingScreen } from "@/components";
import { useLoadingStore } from "@/hooks";
import { ViewProps } from "./View.types";

import styles from "./View.module.scss";

/**
 * View Component
 *
 * Full-screen page shell. Can swap children for a loading screen.
 *
 * @returns Main page container
 */
const View = ({
  children,
  style = {},
  loading = false,
  className = "",
}: ViewProps) => {
  // Clears the global loading flag once the page shell has mounted
  const { setLoading } = useLoadingStore();

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div
      className={classNames(styles.comp, className)}
      style={style}
      role="main"
      aria-busy={loading}
    >
      {/* Full-page spinner while the page asks to stay covered */}
      {loading ? <LoadingScreen /> : children}
    </div>
  );
};

export { View };
